module.exports = __webpack_public_path__ + "img/articles.7b9c0150.jpg";